"use client";

import { Drawer } from "vaul";
import { useWalletPortfolioContext } from "../providers/wallet-portfolio-provider";
import { cn } from "../../../lib/utils";
import { WalletPortfolioBody } from "./WalletPortfolioBody";

export interface WalletPortfolioContentProps {
  className?: string;
}

export function WalletPortfolioContent({
  className,
}: WalletPortfolioContentProps) {
  const {
    env,
    theme,
    walletAddress,
    close,
    onOutlink,
    lpBalanceReader,
    stakingRewardsReader,
  } = useWalletPortfolioContext();

  return (
    <Drawer.Portal>
      <Drawer.Overlay className="wp-overlay" />
      <Drawer.Content
        className={cn("wp-fullscreen", className)}
        data-theme={theme}
      >
        <Drawer.Title className="wp-sr-only">Portfolio</Drawer.Title>
        <WalletPortfolioBody
          env={env}
          theme={theme}
          walletAddress={walletAddress}
          onBack={close}
          variant="none"
          onOutlink={onOutlink}
          lpBalanceReader={lpBalanceReader}
          stakingRewardsReader={stakingRewardsReader}
        />
      </Drawer.Content>
    </Drawer.Portal>
  );
}
